import _ from "lodash";
import bt from "../assets/styles/main.scss";

function addExtendedClass(style,className) {
	if ( style[className] !== undefined ){
		return ` ${style[className]}`;
	}
	return '';
}

function addExtendedClasses(styles,className) {
	var classesString = '';
	_.forEach(styles,(style)=>{
		classesString += addExtendedClass(style,className,classesString);
	})
	return classesString;
}

export default (string,style) => {
		const classes = string.split(' ');
		let classesString = '';
		let extendedClassesFunction = addExtendedClass;
		if (_.isArray(style)){
			extendedClassesFunction = addExtendedClasses;
		}
		_.forEach(classes,className => {
			if (bt[className] !== undefined){
				classesString +=` ${bt[className]}`;
			}
			if (style !== undefined )
			classesString += extendedClassesFunction(style,className,classesString);
		})

		return classesString;
	}


// WEBPACK FOOTER //
// ./src/utils/cssClasses.js